import $ from 'jquery';

export default class GEO {
  constructor() {
    this.lat = 0;
    this.lng = 0;
  }

  init() {
    this.loadInfo();
    this.saveInfo();
  }

  loadInfo() {
    if (this.getCookie('lat') !== '') {
      this.lat = +this.getCookie('lat');
    }
    if (this.getCookie('lng') !== '') {
      this.lng = +this.getCookie('lng');
    }

    if (this.lat === 0 && this.lng === 0) {
      this.readGPS();
    }
  }

  readGPS() {
    navigator.geolocation.getCurrentPosition(
      (e) => {
        this.lat = e.coords.latitude;
        this.lng = e.coords.longitude;
      },
      (e) => {
        console.error(e);
        alert(
          'Wystąpił błąd podczas wczytywania Twojej lokalizacji. Upewnij się, że zezwoliłeś stronie na dostęp do odczytania Twojego położenia.'
        );
      }
    );
  }

  saveInfo() {
    this.setCookie('user_lat', this.lat, 365);
    this.setCookie('user_lng', this.lng, 365);
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}
